var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasswordKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.205,
    height: 18.048,
    viewBox: "0 0 15.205 18.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "fill:#fff"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.1-15.4a4.92,4.92,0,0,0-3.586-1.477A4.862,4.862,0,0,0-1.055-15.4a4.882,4.882,0,0,0-1.477,3.586,5.03,5.03,0,0,0,1.2,3.3.472.472,0,0,0-.422.141l-5.66,5.73a.483.483,0,0,0,0,.773v.035L-4.641.984A.5.5,0,0,0-3.85.967.482.482,0,0,0-3.867.176L-6.223-2.25l1.441-1.477,2.391,2.461A.5.5,0,0,0-1.6-1.283a.482.482,0,0,0-.018-.791L-4.008-4.5-.949-7.559A.472.472,0,0,0-.809-7.98a4.99,4.99,0,0,0,3.34,1.23A4.882,4.882,0,0,0,6.117-8.227a4.882,4.882,0,0,0,1.477-3.586A4.853,4.853,0,0,0,6.1-15.4ZM5.309-9.035a3.789,3.789,0,0,1-2.777,1.16A3.789,3.789,0,0,1-.246-9.035a3.789,3.789,0,0,1-1.16-2.777A3.789,3.789,0,0,1-.246-14.59a3.789,3.789,0,0,1,2.777-1.16,3.789,3.789,0,0,1,2.777,1.16,3.789,3.789,0,0,1,1.16,2.777A3.789,3.789,0,0,1,5.309-9.035Z",
    transform: "translate(7.611 16.875)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordKey);
export default __webpack_public_path__ + "static/media/password-key.0670f7a52e5701feec80676611cf0e01.svg";
export { ForwardRef as ReactComponent };